module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    attrs: {
      "id": "intercom-element"
    }
  }, [_c('div', {
    staticClass: "invoice-box"
  }, [_c('router-link', {
    staticClass: "no-underline dib-ns red mb3 mt4 f4 b invoice-box",
    attrs: {
      "to": "/account/dashboard"
    }
  }, [_c('img', {
    staticClass: "mr1",
    attrs: {
      "src": "/static/appicons/ArrowLeft.svg",
      "alt": ""
    }
  }), _vm._v("\n        Back\n      ")])], 1), _vm._v(" "), _c('h1', {
    staticClass: "f2 lh-copy pt"
  }, [_vm._v("Invoices")]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column justify-between items-start"
  }, _vm._l((_vm.user.invoice_information.all_invoices.slice(0, 10)), function(invoice, index) {
    return _c('div', {
      key: index,
      staticClass: "mb3 invoice-box"
    }, [_vm._m(0, true), _vm._v(" "), _c('label', {
      staticClass: "f6 b",
      attrs: {
        "for": "first_name"
      }
    }, [_vm._v(_vm._s(_vm.invoiceData(invoice)) + " ("), _c('a', {
      staticClass: "red no-underline",
      attrs: {
        "href": invoice.hosted_invoice_url,
        "target": "_blank",
        "rel": "noopener"
      }
    }, [_vm._v("\n        View Invoice")]), _vm._v(")\n        ")])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mr2"
  }, [_c('img', {
    attrs: {
      "src": "/static/appicons/FileText.svg",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3db23eb6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Invoices.vue
// module id = 1511
// module chunks = 0